<template lang="pug">
  v-container(fluid)
    h2.text-center {{ translations.title }}
    v-row.px-2.px-sm-10.pb-10( justify="center")
      v-col(cols="12" md="12")
        v-data-table(
          :headers="headers"
          :items="datos"
          :items-per-page="30"
          :footer-props="{'items-per-page-options': [10, 20, 30, 40, 50], 'itemsPerPageText': $t('api.datatable.rowsperpage')}"
        )
          template(v-slot:body="{ items }")
            tbody
              tr(v-for="item,ind in items"  :key="'item'+ind")
                td
                  span {{ item.cName }}
                td
                  span {{ item.startDate }}
                td
                  span {{ item.endDate }}
                td
                  BaseConfirmDialog(v-bind="translations.confirmationDialog.status" @confirm="toggleState(item.id)")
                    template(v-slot="{ on }")
                      v-btn(v-on="on", :color="getColor(item.status.value)", :loading="loadingToggleFreespins" dark rounded) {{ item.status.text }}
                td
                  v-btn(color="primary" text) View players
    BaseDialog(v-if="hasPermission('views.casino.freespins.createFreespins')" type="create", :title="translationsForm.title.create" v-slot="{close, opened}")
      FreespinsCreate(@successCreate="updateFreespins(opened,close)", :clearForm="opened", :translations="translationsForm")

</template>

<script>

  import FreespinsCreate from '@/components/forms/FreespinsCreate';

  export default {
    name: "FreespinsIndex",
    components: {
      FreespinsCreate,
    },
    // data: () => ({
    // }),
    computed:{
      translations() {
        return this.$t("views.freespinsIndex");
      },
      translationsForm() {
        return this.$t("forms.freespins");
      },
      headers() {
        let headers = [
          {
            text: 'Campaign Name',
            value: 'cName'
          },
          {
            text: 'Start Date',
            value: 'startDate'
          },
          {
            text:'End Date',
            value:'endDate'
          },
          {

            text:'Status',
            value:'status'

          },
          {
            text:' ',
            value:'',
            sortable:false
          }
        ];
        return headers;
      },
      datos(){
        return [
          {
            id: 123,
            cName: 'Test',
            startDate: '01/06/2020',
            endDate: '01/07/2020',
            status:{
              text:'Enabled',
              value:1
            }
          },
          {
            id: 1234,
            cName: 'Test 1',
            startDate: '01/07/2020',
            endDate: '28/07/2020',
            status: {
              text: 'Disabled',
              value: 0
            }
          }]
      },
      loadingToggleFreespins(){
        return this.$store.state.statusCode.toggleFreespins.loading;
      },
      statusToggleState(){
        return this.$store.state.statusCode.toggleFreespins.state || '';
      },
    },
    watch: {
      statusToggleState: function (val) {
        if (val == 200) {
          this.$store.dispatch('getFreespins');
        }
      },
    },
    created() {
      this.$store.dispatch('getFreespins');
    },
    methods: {
      getColor(type){
        return type ? 'green': 'red';
      },
      toggleState(freespinsId){
        this.$store.dispatch('toggleFreespins', freespinsId);
      },
      updateFreespins(opened, closedialog){
        if(opened) {
          if(closedialog != undefined){
            closedialog();
          }
          this.$store.dispatch('getFreespins');
        }
      },
    },
  }
</script>

<style lang="sass">
</style>